import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Box,
  Divider,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import GuideStyles from "assets/js/guide";
import Switch from "@mui/material/Switch";

import "codemirror/lib/codemirror.css";
import "codemirror/theme/dracula.css";
import "codemirror/theme/material.css";

import "codemirror/theme/mdn-like.css";
import "codemirror/theme/the-matrix.css";
import "codemirror/theme/night.css";

import "codemirror/mode/xml/xml";
import "codemirror/mode/javascript/javascript";
import "codemirror/mode/css/css";

import "codemirror/addon/edit/closebrackets";
import "codemirror/addon/edit/closetag";
import { Controlled as ControlledEditor } from "react-codemirror2-react-17";
const label = { inputProps: { "aria-label": "Switch demo" } };
export default function GuideButton() {
  /* Accordion */
  const [codemirror, setCodemirror] = useState();
  const handleCodemirror = (panel) => (event, newcodemirror) => {
    setCodemirror(newcodemirror ? panel : false);
  };

  return (
    <>
      <GuideStyles />
      <main id="main" className="container">
        <Box className="box-type-2">
          <div className="h-group">
            <h2 className="guide-h2">Switch</h2>
          </div>

          <Box>
            <h3 className="guide-h3">Default</h3>
            <Switch {...label} defaultChecked />
          </Box>

          <Accordion
            codemirror={codemirror === "Divider"}
            onChange={handleCodemirror("Divider")}
            className="accordion-codemirror"
          >
            <AccordionSummary>
              <p>코드보기</p>
            </AccordionSummary>
            <AccordionDetails>
              <ControlledEditor
                value={`import Switch from "@mui/material/Switch";

<Switch {...label} defaultChecked />
              `}
                className="code-mirror-wrapper"
                options={{
                  lineWrapping: true,
                  lint: true,
                  mode: "xml",
                  theme: "material",
                  lineNumbers: true,
                }}
              />
            </AccordionDetails>
          </Accordion>
        </Box>
      </main>
    </>
  );
}
